if (!customElements.get('store-area-link')) {
  customElements.define('store-area-link', class StoreAreaLink extends HTMLElement {
    constructor() {
      super();
      this.link = this.querySelector('.js-store-area__link');
      if (this.link) this.link.addEventListener('click', this.onClick.bind(this));
    }
    onClick(e) {
      const text = this.link.textContent.trim().toLowerCase();
      if (!text) return;

      const target = Array.from(document.querySelectorAll('.js-store-grid__title')).find(t => {
        const titleText = t.textContent.trim().toLowerCase();
        return titleText.includes(text) || text.includes(titleText);
      });

      if (target) {
        e.preventDefault();
        (target.closest('.js-store-grid__title-wrapper') || target).scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  });
}

if (!customElements.get('store-area-search')) {
  customElements.define('store-area-search', class StoreAreaSearch extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.input = this.querySelector('.js-store-area-search__input');
      this.dropdown = this.querySelector('.js-store-area-search__dropdown');
      
      setTimeout(() => this.init(), 100);

      if (this.input) {
        this.input.addEventListener('input', this.onInput.bind(this));
        document.addEventListener('click', e => {
          if (!this.contains(e.target)) this.dropdown.hidden = true;
        });
      }
      if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    init() {
      this.items = Array.from(document.querySelectorAll('.js-store-grid__item'));
      this.codes = [...new Set(this.items.map(i => i.dataset.postalCode).filter(Boolean))].sort();
      this.activeQueries = [];
    }

    onInput() {
      const val = this.input.value.trim().toLowerCase();
      this.dropdown.innerHTML = '';
      
      if (!val) {
        this.dropdown.hidden = true;
        return this.filter('');
      }

      const matches = this.codes.filter(c => c.includes(val));
      this.dropdown.hidden = matches.length === 0;
      
      matches.forEach(m => {
        const li = document.createElement('li');
        li.textContent = m;
        li.addEventListener('click', () => {
          this.input.value = m;
          this.dropdown.hidden = true;
          this.filter(m);
        });
        this.dropdown.appendChild(li);
      });
    }

    onSubmit(e) {
      e.preventDefault();
      this.dropdown.hidden = true;
      this.filter(this.input.value.trim().toLowerCase());
    }

    filter(query) {
      if (query && !this.activeQueries.includes(query)) {
        this.activeQueries.push(query);
      }
      this.input.value = '';

      let hasMatch = false;
      this.items.forEach(i => {
        const itemCode = i.dataset.postalCode || '';
        const match = this.activeQueries.length === 0 || this.activeQueries.some(q => itemCode.includes(q));
        i.style.display = match ? '' : 'none';
        i.classList.toggle('hidden-by-search', !match);
        if (match) hasMatch = true;
      });

      document.querySelectorAll('.js-store-grid-list').forEach(list => {
        const hasVisible = !!list.querySelector('.js-store-grid__item:not(.hidden-by-search)');
        list.style.display = hasVisible ? '' : 'none';
        
        const title = list.previousElementSibling;
        if (title?.classList.contains('js-store-grid__title-wrapper')) {
          title.style.display = hasVisible ? '' : 'none';
        }
      });
      
      this.renderTags();

      if (this.activeQueries.length > 0 && hasMatch) {
        const first = document.querySelector('.js-store-grid__title-wrapper:not([style*="none"])') || 
                      document.querySelector('.js-store-grid-list:not([style*="none"])');
        if (first) first.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    renderTags() {
      this.tagsContainer = document.querySelector('.js-store-grid-tags-container');
      if (!this.tagsContainer) return;

      // Remove existing tags, keep the label
      this.tagsContainer.querySelectorAll('.store-grid-search-tags__tag').forEach(el => el.remove());

      if (this.activeQueries.length === 0) {
        this.tagsContainer.hidden = true;
        return;
      }
      
      this.tagsContainer.hidden = false;
      
      this.activeQueries.forEach(q => {
        const tag = document.createElement('button');
        tag.type = 'button';
        tag.className = 'store-grid-search-tags__tag';
        tag.innerHTML = `${q} <span class="store-grid-search-tags__tag-remove" aria-hidden="true">✕</span>`;
        tag.addEventListener('click', () => {
          this.activeQueries = this.activeQueries.filter(aq => aq !== q);
          this.filter('');
        });
        this.tagsContainer.appendChild(tag);
      });
    }
  });
}
